import Vue from 'vue'
import App from './App.vue'
import VueSocketIO from 'vue-socket.io'
import './assets/css/global.css';
import router from './router.js';
import store from './store.js';
import {location} from './Location.js';
import VueRouter from 'vue-router';
// es-6 promise is required for the store
import 'es6-promise/auto'

Vue.config.productionTip = false

//aanpassing maken voor desbetreffende poort 
const loc = location()

Vue.use(new VueSocketIO({
  debug: true,
  connection:loc
}))



new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
